import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import { LanguageProvider, useLanguage } from "./contexts/LanguageContext";
import { Header } from "./components/Header";
import { Hero } from "./components/Hero";
import { Pricing } from "./components/Pricing";
import { About } from "./components/About";
import { Gallery } from "./components/Gallery";
import { Contact } from "./components/Contact";
import { Footer } from "./components/Footer";
import { WhatsAppFloat } from "./components/WhatsAppFloat";
import Impressum from "./pages/Impressum";
import Datenschutz from "./pages/Datenschutz";

const HomePage = () => {
  const { t } = useLanguage();

  return (
    <div
      className="App min-h-screen bg-[#0A0D14] text-white"
      data-testid="home-page"
    >
      <Header />
      <main>
        <Hero />
        <Pricing />
        <About />
        <Gallery />
        <Contact />
      </main>
      <Footer t={t} />
      <WhatsAppFloat label={t.whatsapp_float} />
    </div>
  );
};

function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/impressum" element={<Impressum />} />
          <Route path="/datenschutz" element={<Datenschutz />} />
          <Route path="*" element={<HomePage />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        position="top-center"
        theme="dark"
        toastOptions={{
          style: {
            background: "#121722",
            border: "1px solid rgba(255,255,255,0.1)",
            color: "#fff",
          },
        }}
      />
    </LanguageProvider>
  );
}

export default App;
